<template>
  <div
    class="isloading-animate"
    :class="{primary:primary}"
    :style="{width:size+'px',height:size+'px'}"
  >
    <div :style="{width:size+'px',height:size+'px'}"/>
    <div :style="{width:size+'px',height:size+'px'}"/>
    <div :style="{width:size+'px',height:size+'px'}"/>
    <div :style="{width:size+'px',height:size+'px'}"/>
  </div>
</template>
<script>
export default {
  name: "LoadingAnimate",
  props: {
    size: {
      type: Number,
      default: 20,
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.isloading-animate {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  &.primary {
    div {
      border: 2px solid var(--blue-500);
      border-color: var(--blue-500) transparent transparent transparent;
    }
  }
}
.isloading-animate div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.isloading-animate div:nth-child(1) {
  animation-delay: -0.45s;
}
.isloading-animate div:nth-child(2) {
  animation-delay: -0.3s;
}
.isloading-animate div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>